<template>
<div class="chapter">
<div class="inner_page">
<p><a id="p01"></a></p>
<div class="ct"><i><b>Part One</b></i></div>
<div class="cst"><b> 1928 – 1939</b></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// vinc_9781590207963_oeb_p01_r1.vue?7ae46d98